export const __FIELD_TYPE_UPLOAD__ = 'UPLOAD';
export const __FIELD_TYPE_INPUT__ = 'INPUT';
export const __FIELD_TYPE_SELECT__ = 'SELECT';
export const __FIELD_TYPE_DATE__ = 'DATE';
export const __FIELD_TYPE_CHECKBOX__ = 'CHECKBOX';